// import http from "../common/http-common";
// import { jwtDecode } from "jwt-decode";

import http from "../common/http-common";

export async function doLogin(data) {
  return http.post("/b2b/login", data);
}

export async function resetPassword(data){
  return http.put("/b2b/resetpwd", data);
}
